import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/config/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import LoginView from '@/views/LoginView.vue'
import HomeView from '@/views/HomeView.vue'
import TechnopawsView from '@/views/TechnopawsView.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'Technopaws',
    component: TechnopawsView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  onAuthStateChanged(auth, (user) => {
    if (requiresAuth && !user) {
      next({ name: 'Login' })
    } else if (to.name === 'Login' && user) {
      next({ name: 'Home' })
    } else {
      next()
    }
  })
})

export default router
